import { Dialog } from "js/editor/ui";
import { app } from "js/namespaces";
import * as analytics from "js/analytics";

const AnalyticsOptInDialog = Dialog.extend({
    canClose: false,

    initialize: function(options) {
        Dialog.prototype.initialize.call(this, options);
        this.workspaceId = options.workspaceId;
    },

    getTitle: function() {
        return "We've expanded our privacy options";
    },

    renderContents: function($contents) {
        $contents.append(`
            <p style="font-weight: 600">Beautiful.ai is committed to ensuring that your personal and presentation data remains secure and private.</p>
            <div style="float:left; width:50px; height: 50px; border: solid 1px #11A9E2; color: #11A9E2; display:flex; align-items:center; justify-content: center; margin: 0px 10px;">
                <i class="material-icons" style="font-size: 24px">lock</i>
            </div>
            <p style="margin-bottom:30px">
            Any presentations you create in Beautiful.ai are private by default and only viewable by you or those you give explicit permission to edit or view.
            </p>
                <div style="float:left; width:50px; height: 50px; border: solid 1px #11A9E2; color: #11A9E2; display:flex; align-items:center; justify-content: center; margin: 0px 10px;">
                <i class="material-icons" style="font-size: 24px">public</i>
            </div>
            <p style="margin-bottom:30px">
            Any presentations that you choose to make public will be viewable by anyone with the public link or embeddable into a website or blog.
            </p>
                <div style="float:left; width:50px; height: 50px; border: solid 1px #11A9E2; color: #11A9E2; display:flex; align-items:center; justify-content: center; margin: 0px 10px;">
                <i class="material-icons" style="font-size: 24px">remove_red_eye</i>
            </div>
            <p style="margin-bottom:30px">
            It is our policy that employees of Beautiful.ai will not view personal or presentation data without explicit permission from the account owner. 
            </p>
            <div style="float:left; width:50px; height: 50px; border: solid 1px #11A9E2; color: #11A9E2; display:flex; align-items:center; justify-content: center; margin: 0px 10px;">
                <i class="material-icons" style="font-size: 24px">track_changes</i>
            </div>
            <div style="display:inline-block; width: 660px; margin-bottom: 20px">
            <p style="margin-bottom:10px"> 
            Occasionally, we may review or inspect your presentation data in order to help us improve Beautiful.ai and diagnose issues. Reviewed data will never be shared with third-parties or used for marketing purposes.
            </p>
            <p>
            <input id='optIn' type="checkbox" checked="true"/>
            <label for='optIn' style="font-weight: 600">Allow Beautiful.ai to inspect my presentation data for internal purposes only</label>
            <!--<label for='optIn' style="font-weight: 600">Allow us to occasionally inspect your presentation data in order to help us improve Beautiful.ai and diagnose issues. Collected data will never be shared with third-parties or used for marketing purposes.</label>-->
            </p>
            </div>
        `);
        this.renderButtons($contents, { acceptLabel: "Ok", showCancel: false });
    },

    onAcceptDialog: function() {
        const trackUsageData = this.$el.find("input").prop("checked");
        app.user.update({ trackUsageData });
        analytics.track();
        analytics.audit("audit", "allow-tracking", { value: trackUsageData, workspace_id: this.workspaceId });
        this.close();
    }
});

export default AnalyticsOptInDialog;
